class Clipboard {

	static copyToClipboard = async (text: string): Promise<void> => {
		if (navigator.clipboard) {
			await navigator.clipboard.writeText(text);
		} else {
			const tmpTextArea = document.createElement("textarea");
			tmpTextArea.value = text;
			tmpTextArea.style.position = "fixed";
			tmpTextArea.style.top = "-1000px";
			tmpTextArea.style.left = "-1000px";
			tmpTextArea.style.background = "transparent";
			document.body.appendChild(tmpTextArea);
			tmpTextArea.focus();
			tmpTextArea.select();

			document.execCommand("copy");

			document.body.removeChild(tmpTextArea);
		}
	}
}

export default Clipboard;